import { IGetGestaoEpiByIdUseCase } from "../../../presentation/useCases/read/get_gestao_epi_by_id_use_case";
import { GestaoEpi } from "../../models/gestao_epi";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * GetGestaoEpiByIdUseCase
 */

export class GetGestaoEpiByIdUseCase implements IGetGestaoEpiByIdUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async getGestaoEpiById(
    idGestaoEpi: number,
  ): Promise<GestaoEpi> {
    const result = await this.repository.getGestaoEpiById(idGestaoEpi);
    if (result === null) throw new Error('Falha ao buscar gestão de epi!');
    return result;
  }
}
